<template >
  <div>
    <a-badge :count="$store.state.num">
      <a class="action ant-dropdown-link user-dropdown-menu" @click="HoldOrder"> 挂起订单 </a>
    </a-badge>

    <!--&lt;!&ndash;待办事项&ndash;&gt;-->
    <!--<backlog ref="model2" ></backlog>-->
    <hold-order-model ref="model"></hold-order-model>
  </div>
</template>

<script>
import HoldOrderModel from './HoldOrderModel'
import { checkPermission } from '@/utils/permissions'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  name: 'Holdorder',
  components: {
    HoldOrderModel,
  },
  data() {
    return {
      total: 0,
      // ToDoListTypeEnable: checkPermission('ToDoListType'),//待办事项
    }
  },
  async created() {},
  methods: {
    HoldOrder() {
      this.$refs.model.add()
    },
  },
}
</script>

<style scoped>
</style>